(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class EbBannerSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-eb-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.eb-banner-slideshow__slide'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-eb-dot]'));
      if (!this.track || this.slides.length <= 1) return;

      this.current = 0;
      this.rafPending = false;

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.initDots();
      this.initDrag();
      this.initAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    /* ── Dots ── */
    initDots() {
      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-eb-dot'), 10) || 0;
          this.goTo(i);
          this.pauseAutoplay();
        }.bind(this));
      }, this);
    }

    goTo(index) {
      var slide = this.slides[index];
      if (!slide) return;
      this.track.scrollTo({
        left: slide.offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    setActive(index) {
      if (index === this.current) return;
      this.current = index;
      this.dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    onScroll() {
      if (this.rafPending) return;
      this.rafPending = true;
      requestAnimationFrame(function () {
        this.rafPending = false;
        var center = this.track.scrollLeft + this.track.clientWidth / 2;
        var nearest = 0;
        var min = Infinity;
        this.slides.forEach(function (slide, i) {
          var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          var dist = Math.abs(slideCenter - center);
          if (dist < min) {
            min = dist;
            nearest = i;
          }
        });
        this.setActive(nearest);
      }.bind(this));
    }

    /* ── Mouse drag (touch uses native scroll) ── */
    initDrag() {
      var self = this;
      var down = false;
      var startX = 0;
      var startScroll = 0;
      var startIndex = 0;
      var dx = 0;
      var moved = false;

      this.track.addEventListener('mousedown', function (e) {
        down = true;
        moved = false;
        dx = 0;
        startX = e.pageX;
        startScroll = self.track.scrollLeft;
        startIndex = self.current;
        self.pauseAutoplay();
      });

      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        dx = e.pageX - startX;
        /* Only past a real threshold — a plain click carries a few px of jitter.
           `is-dragging` (pointer-events:none on the slides) is added only once a
           real drag starts; adding it on every mousedown made the slide
           non-interactive mid-press, so its link click never fired. */
        if (Math.abs(dx) > 8 && !moved) {
          moved = true;
          self.track.classList.add('is-dragging');
        }
        if (!moved) return;
        /* Slight multiplier so the slide tracks the cursor with less effort */
        self.track.scrollLeft = startScroll - dx * 1.15;
        e.preventDefault();
      });

      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        self.track.classList.remove('is-dragging');
        if (moved) self.commitDrag(dx, startIndex);
      });

      /* Swallow the click that follows a real drag so links don't fire */
      this.track.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
    }

    /* Commit a drag: advance one slide once dragged past a light threshold
       (~15% of the viewport), instead of requiring a full half-slide drag. */
    commitDrag(dx, startIndex) {
      var threshold = this.track.clientWidth * 0.15;
      var target = startIndex;
      if (dx <= -threshold) target = startIndex + 1;
      else if (dx >= threshold) target = startIndex - 1;
      target = Math.max(0, Math.min(this.slides.length - 1, target));
      this.goTo(target);
    }

    /* ── Autoplay ── */
    initAutoplay() {
      this.autoplayOn = this.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      this.speed = (parseInt(this.getAttribute('data-speed'), 10) || 5) * 1000;
      if (!this.autoplayOn) return;

      this.startAutoplay();

      this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
      this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      this.addEventListener('focusin', this.stopAutoplay.bind(this));
      this.addEventListener('focusout', this.startAutoplay.bind(this));
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      }.bind(this));
    }

    startAutoplay() {
      if (!this.autoplayOn || this.timer) return;
      this.timer = setInterval(function () {
        var next = (this.current + 1) % this.slides.length;
        this.goTo(next);
      }.bind(this), this.speed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    /* Pause briefly after a manual interaction, then resume */
    pauseAutoplay() {
      if (!this.autoplayOn) return;
      this.stopAutoplay();
      clearTimeout(this.resumeTimer);
      this.resumeTimer = setTimeout(this.startAutoplay.bind(this), this.speed);
    }
  }

  if (!customElements.get('eb-banner-slideshow')) {
    customElements.define('eb-banner-slideshow', EbBannerSlideshow);
  }
})();
